import React from 'react';

const Testinomials=()=>{
    return(
        <h1>Testinomials</h1>
    )
}

export default Testinomials